import React from "react"
import { X } from "lucide-react"
import { Button } from "src/components/ui/button"

// Determines readable text color (black or white) based on hex background.
function getContrastColor(hex) {
  const h = hex.replace("#", "")
  const r = parseInt(h.substring(0, 2), 16)
  const g = parseInt(h.substring(2, 4), 16)
  const b = parseInt(h.substring(4, 6), 16)
  const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255
  return luminance > 0.5 ? "#1e293b" : "#ffffff"
}

export function TagBadge({ tag, onRemove }) {
  const color = tag.color || "#64748B"
  const textColor = getContrastColor(color)

  return (
    <span
      className="inline-flex items-center gap-1 rounded-full px-2.5 py-0.5 text-[12px] font-medium"
      style={{ backgroundColor: color, color: textColor }}
    >
      {tag.name}
      {onRemove && (
        <Button
          type="button"
          variant="ghost"
          size="icon"
          onClick={(e) => { e.stopPropagation(); onRemove(tag) }}
          className="ml-0.5 h-auto w-auto rounded-full p-0.5 text-current transition-colors hover:bg-black/10"
          aria-label={`Remove ${tag.name}`}
        >
          <X className="h-2.5 w-2.5" />
        </Button>
      )}
    </span>
  )
}
